/**
 * Evaluates a passed string and returns a css classname
 * @param {string} status the status to be evaluated
 */
const getColourClassStatus = (status) => {
    //if (status == "InTransit") return "inTransit"
    if (status == "Confirmed") return "approved"
    else if (status == "Inaccurate") return "correction"
    else return "inTransit"
}

/**
 * Evaluates a boolean to return a css classname
 * @param {boolean} inaccurateState
 */
const correctionColor = (inaccurateState) => {
    return (inaccurateState == true ? "correction-corrected" : "correction-approved")
}

export { getColourClassStatus, correctionColor }